// The Home greeting follows the device's local clock.
//   morning    05:00 – 11:59
//   afternoon  12:00 – 17:59
//   evening    18:00 – 04:59 (late night reads as evening, never as morning)
export const MORNING_START_HOUR = 5;
export const AFTERNOON_START_HOUR = 12;
export const EVENING_START_HOUR = 18;

export function getHomeGreeting(date = new Date()) {
  const hour = date.getHours();
  if (hour >= MORNING_START_HOUR && hour < AFTERNOON_START_HOUR) return "Good morning";
  if (hour >= AFTERNOON_START_HOUR && hour < EVENING_START_HOUR) return "Good afternoon";
  return "Good evening";
}
